import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { formatCurrencyDecimals } from 'utils/formats';
import { useBeneficiarySellModal } from '../context/BeneficiarySellModalContext';

const PlanTableFooter: FC = () => {
  const { t } = useTranslate();

  const { data } = useBeneficiarySellModal();

  return (
    <tfoot>
      <tr>
        <td colSpan={6} />
        <td className="text-right" colSpan={2}>
          {t('Subtotal')}
        </td>
        <td />
        <td className="text-right">
          {formatCurrencyDecimals(data.simulatedTotal)}
        </td>
      </tr>

      <tr>
        <td colSpan={6} />
        <td className="text-right" colSpan={2}>
          {t('Retention')}
        </td>
        <td />
        <td className="text-right">
          -{formatCurrencyDecimals(data.retentionTotal)}
        </td>
      </tr>

      <tr>
        <td colSpan={6} />
        <td className="text-right fw-bold" colSpan={2}>
          {t('Total')}
        </td>
        <td />
        <td className="text-right fw-bold">
          {formatCurrencyDecimals(data.simulatedTotal - data.retentionTotal)}
        </td>
      </tr>
    </tfoot>
  );
};

export default PlanTableFooter;
